import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _Object$values from "@babel/runtime-corejs3/core-js/object/values";
import _sortInstanceProperty from "@babel/runtime-corejs3/core-js/instance/sort";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { semverRegex } from "@Shared/utils/utils";
import { mapState, mapActions } from "vuex";
import { LOAD_NOTIFICATIONS, CLEAR_READ_STATUS, CLEAR_RELEASE_NOTES } from "../../store/activity-center-actions";
import ReleaseNoteLoader from "./loaders/release-note-loader.vue";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "ReleaseNotesTabs",
  components: {
    ReleaseNoteLoader
  },
  data() {
    return {
      loading: true,
      loadingNotes: false,
      offset: 0,
      limit: 10,
      shouldFetchMore: true
    };
  },
  computed: _objectSpread({}, mapState("ActivityCenterStore", {
    releaseNotes(state) {
      return state.releaseNotes.byId;
    },
    sortedReleaseNotes() {
      const sortedReleaseNotes = _Object$values(this.releaseNotes);
      _sortInstanceProperty(sortedReleaseNotes).call(sortedReleaseNotes, (a, b) => {
        //eslint-disable-next-line no-unused-vars, @typescript-eslint/no-unused-vars
        const [fullMatchA, majorA, minorA, patchA] = a.version.replace(/^v/, "").match(semverRegex);
        //eslint-disable-next-line no-unused-vars, @typescript-eslint/no-unused-vars
        const [fullMatchB, majorB, minorB, patchB] = b.version.replace(/^v/, "").match(semverRegex);
        if (Number(majorA) > Number(majorB)) return -1;
        if (Number(majorA) < Number(majorB)) return 1;
        if (Number(minorA) > Number(minorB)) return -1;
        if (Number(minorA) < Number(minorB)) return 1;
        if (Number(patchA) > Number(patchB)) return -1;
        if (Number(patchA) < Number(patchB)) return 1;
        return 0;
      });
      return sortedReleaseNotes;
    }
  })),
  async beforeMount() {
    this.loading = true;
    await this.LOAD_NOTIFICATIONS({
      offset: this.offset,
      limit: this.limit
    });
    this.loading = false;
  },
  beforeDestroy() {
    this.CLEAR_READ_STATUS({
      type: "releaseNotes"
    });
    this.CLEAR_RELEASE_NOTES();
  },
  methods: _objectSpread(_objectSpread({}, mapActions("ActivityCenterStore", [CLEAR_READ_STATUS, LOAD_NOTIFICATIONS, CLEAR_RELEASE_NOTES])), {}, {
    async loadReleaseNotes() {
      if (!this.shouldFetchMore || this.loadingNotes) return;
      this.loadingNotes = true;
      this.shouldFetchMore = await this.LOAD_NOTIFICATIONS({
        offset: this.offset,
        limit: this.limit
      });
      this.offset += this.limit;
      this.loadingNotes = false;
    },
    onScrollBottom({
      target: {
        scrollTop,
        clientHeight,
        scrollHeight
      }
    }) {
      if (scrollTop + clientHeight >= scrollHeight) {
        this.loadReleaseNotes();
      }
    }
  })
});